(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pergolast-popup')) {
    customElements.define('pergolast-popup', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.panel = this.querySelector('.pg-panel');
        this.launcher = this.querySelector('.pg-launcher');
        this.frame = this.querySelector('iframe');
        if (!this.panel) return;
        this.editor = Boolean(window.Shopify?.designMode);
        this.querySelector('.pg-close').addEventListener('click', () => this.close(), options);
        this.launcher.addEventListener('click', () => this.open(true), options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !this.panel.hidden) this.close();
        }, options);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden && this.pending) this.open();
        }, options);
        if (this.editor) {
          this.launcher.hidden = false;
          if (this.dataset.preview === 'true') this.open();
          return;
        }
        if (this.read('seen') === '1') { this.launcher.hidden = false; return; }
        let start = Number(this.read('start'));
        if (!start || start > Date.now()) { start = Date.now(); this.write('start', String(start)); }
        this.timer = setTimeout(() => this.open(), Math.max(0, Number(this.dataset.delay) * 1000 - (Date.now() - start)));
      }
      read(key) {
        try { return sessionStorage.getItem('pergolast-popup-v1:' + key); }
        catch (error) { this.warn(error); return this[key] || null; }
      }
      write(key, value) {
        this[key] = value;
        try { sessionStorage.setItem('pergolast-popup-v1:' + key, value); }
        catch (error) { this.warn(error); }
      }
      warn(error) {
        if (!this.warned) console.warn('[Pergolast popup] Session storage unavailable; timing applies to this page.', error);
        this.warned = true;
      }
      open(manual = false) {
        clearTimeout(this.timer);
        if (document.hidden) { this.pending = true; return; }
        this.pending = false;
        this.panel.hidden = false;
        this.launcher.hidden = true;
        this.launcher.setAttribute('aria-expanded', 'true');
        if (!this.editor) this.write('seen', '1');
        if (!this.frame.hasAttribute('src')) {
          const status = this.querySelector('.pg-status');
          this.frame.addEventListener('load', () => { status.hidden = true; clearTimeout(this.loadTimer); }, { once: true, signal: this.abort.signal });
          this.loadTimer = setTimeout(() => {
            status.hidden = true;
            console.warn('[Pergolast popup] Form load timed out. Use the direct form link.');
          }, 15000);
          this.frame.src = this.frame.dataset.src;
          if (!document.querySelector('script[src="https://link.msgsndr.com/js/form_embed.js"]')) {
            const script = document.createElement('script');
            script.src = 'https://link.msgsndr.com/js/form_embed.js';
            script.async = true;
            script.onerror = () => console.warn('[Pergolast popup] Embed helper could not load; direct form link remains available.');
            document.head.appendChild(script);
          }
        }
        if (manual) this.querySelector('.pg-close').focus({ preventScroll: true });
      }
      close() {
        const restoreFocus = this.contains(document.activeElement);
        this.panel.hidden = true;
        this.launcher.hidden = false;
        this.launcher.setAttribute('aria-expanded', 'false');
        if (restoreFocus) this.launcher.focus({ preventScroll: true });
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.loadTimer);
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
